// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-pad-container {
  height: auto;
  overflow-y: auto;
  border-radius: 8;
  margin-bottom: 12px;
  padding: 20px;
}
.chat-pad-container-all {
  height: 42vh;
}
.chat-disclaimer {
  font-family: Roboto;
  font-weight: 400;
  font-style: Medium;
  font-size: 14px;
  color: #000;
  line-height: 18.2px;
  margin-top: 10px;
  margin-bottom: 5px;
  text-align: center;
}
.chat-pad-container {
  max-height: 60vh;
  overflow-y: auto;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 20px;
  scrollbar-width: thin;
  scrollbar-color: #98a2b3 transparent;
}
.rotate-icon {
  transform: rotate(-90deg);
}
.chat-pad-container::-webkit-scrollbar {
  width: 6px;
}

.chat-pad-container::-webkit-scrollbar-track {
  background: transparent;
}

.chat-pad-container::-webkit-scrollbar-thumb {
  background: #98a2b3;
  border-radius: 10px;
}

.chat-pad-container::-webkit-scrollbar-thumb:hover {
  background: #667085;
}

.chat-pad-container-all {
  height: 42vh;
}
@media (max-width: 769px) {
  .chat-pad-container {
    height: 430px;
  }
}
.terms-chat-card {
  width: 100%;
  max-width: 390px;
  padding: 14px 16px;
  border: 1px solid #f5d15c;
  border-radius: 16px;
  background: #fffdf2;
  box-sizing: border-box;
  margin-top: 10px;
}
.terms-chat-card-counter {
  border: 2px solid #d2042d !important;
  background: #fff0f2 !important;
}
.terms-chat-card-counter-reciever {
  background: #dbeafe !important;
  border: 2px solid #1447e6 !important;
}
.terms-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 14px;
}

.terms-chat-title {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #d97706;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.terms-chat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: 1px solid #f5d15c;
  border-radius: 50%;
}

.terms-chat-status {
  padding: 4px 8px;
  border-radius: 12px;
  background: #fff0b8;
  color: #d97706;
  font-size: 11px;
  white-space: nowrap;
}

.terms-chat-total {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin-bottom: 12px;
}

.terms-chat-total-amount {
  color: #101828;
  font-size: 24px;
  font-weight: 700;
}

.terms-chat-total-label {
  color: #475467;
  font-size: 12px;
}

.terms-chat-table {
  overflow: hidden;
  border: 1px solid #f5d15c;
  border-radius: 12px;
}
.terms-chat-table .ant-table {
  background: transparent;
}

.terms-chat-table .ant-table-container {
  border: none !important;
}

.terms-chat-table .ant-table-thead > tr > th {
  padding: 8px 10px;
  background: #fff3c4 !important;
  color: #d97706 !important;
  font-size: 11px;
  font-weight: 500;
  border-bottom: 1px solid #f5d15c;
}

.terms-chat-table .ant-table-thead > tr > th::before {
  display: none !important;
}

.terms-chat-table .ant-table-tbody > tr > td {
  padding: 9px 10px;
  color: #344054;
  font-size: 12px;
  border-bottom: 1px solid #f5d15c;
}

.terms-chat-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none;
}

.terms-percentage {
  color: #98a2b3;
  font-size: 10px;
}

.terms-chat-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 10px;
  background: #fff8dc;
  color: #d97706 !important;
  font-size: 12px;
  font-weight: 600;
}

.terms-chat-card {
  padding: 12px 16px 14px;
  border: 1px solid #f5d15c;
  border-radius: 16px;
  background: #fffdf2;
  box-sizing: border-box;
  margin-top: 0;
}

.terms-chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 14px;
}

.terms-chat-title {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #d97706;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  white-space: nowrap;
}

.terms-chat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px !important;
  height: 22px !important;
  opacity: 1;
  border-radius: 8px;
  border-width: 1px;
  border: 1px solid #d9770640 !important;
  background: #fff3c4 !important;
  color: #d97706;
  font-size: 12px;
  flex-shrink: 0;
}
.terms-chat-approve-icon {
  background: transparent !important;
  color: #064e3b !important;
  border: 1px solid #4ade80 !important;
  background-color: #4ade80;
}
.terms-chat-icon-counter {
  background-color: #d2042d !important;
  color: #fff !important;
  border-radius: 8px !important;
}
.terms-chat-status {
  padding: 4px 8px;
  border-radius: 12px;
  background: #fff0b8;
  color: #d97706;
  font-size: 11px;
  font-weight: 400;
  white-space: nowrap;
  flex-shrink: 0;
}
.terms-chat-status-counter {
  color: #d2042d !important;
  background-color: transparent !important;
}
.counter-header-text-sender {
  color: #d2042d !important;
}
.terms-chat-status-counter-sent {
  background-color: #dbeafe !important;
}
.counter-header-text {
  color: #1447e6 !important;
}
.terms-chat-reciver-counter {
  background: #fff0f2 !important;
}
.terms-chat-icon-counter-receiver {
  background: #dbeafe !important;
  border: 1px solid #1447e6 !important;
  width: 16;
  height: 16;
  border-radius: 4px;
}
.terms-chat-total {
  display: flex;
  align-items: baseline;
  gap: 7px;
  margin-bottom: 14px;
}

.terms-chat-total-amount {
  color: #101828;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}

.terms-chat-total-label {
  color: #475467;
  font-size: 11px;
  font-weight: 400;
}

.terms-chat-table {
  width: 100%;
  overflow: hidden;
  border: 1px solid #f5d15c;
  border-radius: 12px;
}

.terms-chat-table .ant-table {
  background: transparent;
}

.terms-chat-table .ant-table-container {
  border: none !important;
}

.terms-chat-table .ant-table-thead > tr > th {
  padding: 7px 10px !important;
  background: #fff3c4 !important;
  color: #d97706 !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #f5d15c !important;
}

.terms-chat-table .ant-table-thead > tr > th::before {
  display: none !important;
}

.terms-chat-table .ant-table-tbody > tr > td {
  padding: 8px 10px !important;
  color: #344054 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #f5d15c !important;
}
.terms-percentage {
  color: #98a2b3 !important;
  font-size: 10px !important;
}

.terms-chat-table .ant-table-tbody > tr.terms-chat-total-row > td {
  padding: 8px 10px !important;
  color: #d97706 !important;
  font-size: 12px  !important;
  font-weight: 600 !important;
  border-bottom: none !important;
}

.counter-offer-chat-content {
  padding: 0 2px 8px;
}

.counter-offer-chat-price {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-bottom: 8px;
}

.counter-offer-chat-amount {
  font-size: 24px;
  line-height: 28px;
  font-weight: 600;
  color: #101828;
}

.counter-offer-chat-period {
  font-size: 12px;
  color: #475569;
}

.counter-offer-chat-schedule {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #475569;
  line-height: 20px;
}

.counter-offer-chat-dollar {
  flex: 0 0 auto;
  color: #98a2b3;
  font-size: 13px;
}

.counter-offer-chat-schedule-label {
  flex: 0 0 auto;
  white-space: nowrap;
}

.counter-offer-chat-schedule-values {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.counter-offer-chat-schedule-row {
  display: flex;
  gap: 4px;
  white-space: nowrap;
}
.counter-offer-chat-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.counter-offer-chat-actions .counter-offer-chat-accept,
.counter-offer-chat-actions .counter-offer-chat-counter {
  flex: 1 1;
  height: 30px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
}

.counter-offer-chat-accept {
  background: #00a63e !important;
  border-color: #00a63e !important;
  color: #fff !important;
}

.counter-offer-chat-counter {
  background: transparent !important;
  border-color: #8b9cff !important;
  color: #3b4eff !important;
}
.baground-color {
  background: #dbeafe !important;
}
.text-bold-style {
  font-family: Roboto;
  font-size: 12px !important;
  font-weight: 500 !important;
}
.border-styles {
  border-radius: 8px !important;
  height: 30px !important;
}
.counter-chat-table {
  width: 100%;
  overflow: hidden;
  border: 1px solid #1447e6 !important;
  border-radius: 12px;
  background: #dbeafe !important;
}
.counter-chat-table .ant-table,
.counter-chat-table .ant-table-container,
.counter-chat-table .ant-table-content {
  background: #dbeafe !important;
}
.counter-chat-table .ant-table-thead > tr > th {
  padding: 7px 10px !important;
  background: #93b4f8 !important;
  color: #000 !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #93b4f8 !important;
}

.counter-chat-table .ant-table-tbody > tr > td {
  padding: 8px 10px !important;
  background: #dbeafe !important;
  color: #475569 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #93b4f8 !important;
}

.counter-chat-table .ant-table-tbody > tr.ant-table-row:hover > td {
  background: #dbeafe !important;
}
.counter-chat-table .ant-table-tbody > tr:last-child > td {
  border-bottom: none !important;
}

.counter-chat-table .ant-table-tbody > tr.terms-chat-total-row > td {
  background: #dbeafe !important;
  color: #475569 !important;
  font-size: 12px;
  font-weight: 600;
  border-bottom: none !important;
}

.counter-chat-table .terms-percentage {
  color: #64748b !important;
  font-size: 10px;
}

.counter-chat-table .ant-table-thead > tr > th::before {
  display: none !important;
}

.counter-chat-table-seller {
  width: 100%;
  overflow: hidden;
  border: 1px solid #d2042d !important;
  border-radius: 12px;
  background: #fff0f2 !important;
}

.counter-chat-table-seller .ant-table,
.counter-chat-table-seller .ant-table-container,
.counter-chat-table-seller .ant-table-content {
  background: #fff0f2 !important;
}

.counter-chat-table-seller .ant-table-thead > tr > th {
  padding: 7px 10px !important;
  background: #f5c2ca !important;
  color: #d2042d !important;
  font-size: 11px !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #f5c2ca !important;
}

.counter-chat-table-seller .ant-table-tbody > tr > td {
  padding: 8px 10px !important;
  background: #fff0f2 !important;
  color: #475569 !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #f5c2ca !important;
}
.counter-chat-table-seller .ant-table-tbody > tr.ant-table-row:hover > td {
  background: #fff0f2 !important;
}
.counter-chat-table-seller .ant-table-tbody > tr:last-child > td {
  border-bottom: none !important;
}

.counter-chat-table-seller .ant-table-tbody > tr.terms-chat-total-row > td {
  background: #fff0f2 !important;
  color: #475569 !important;
  font-size: 12px;
  font-weight: 600;
  border-bottom: none !important;
}

.counter-chat-table-seller .terms-percentage {
  color: #98a2b3 !important;
  font-size: 10px;
}
.counter-chat-table-seller .ant-table-thead > tr > th::before {
  display: none !important;
}
.offer-accepted-message {
  width: 60%;
  margin: 20px auto;
  padding: 12px 16px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 2px solid #6ee7a0;
  border-radius: 16px;
  background: #f0fdf4;
  font-family: Roboto;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  display: flex;
}

/* Latest agreed message - Buyer & Seller */

.agreed-latest-message {
  background: #f0fdf4 !important;
  border: 2px solid #4ade80 !important;
  border-radius: 16px !important;
  padding: 16px !important;
  color: #064e3b !important;
  box-shadow: none !important;
}

/* Accepted terms card */

.terms-chat-card.agreed-latest-message {
  background: #f0fdf4;
  border: 2px solid #4ade80;
  border-radius: 16px;
}

/* Accepted card text */

.agreed-latest-message .terms-chat-title,
.agreed-latest-message .terms-chat-total-amount,
.agreed-latest-message .terms-chat-total-label {
  color: #064e3b;
}

/* Green accepted status */

.agreed-latest-message .terms-chat-status {
  background: #dcfce7;
  color: #15803d;
  border-radius: 20px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 600;
}

/* Payment schedule / table */

.agreed-latest-message .terms-chat-table {
  background: transparent;
  border: 1px solid #4ade80;
}

.agreed-latest-message .terms-chat-table .ant-table-cell {
  background: transparent !important;
  color: #064e3b !important;
  border-bottom: 1px solid #4ade80 !important;
}
.offer-declined-message {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  max-width: 100%;
  margin: 16px auto;
  padding: 12px 24px;
  border: 1px solid #e5e7eb;
  border-radius: 24px;
  background-color: #f3f4f6;
  color: #64748b;
  font-family: Roboto, sans-serif;
  font-size: 13px;
  line-height: 1.5;
  text-align: left;
}

.declined-icon {
  flex-shrink: 0;
  color: #ff477e;
  font-size: 16px;
  font-weight: 600;
}
.approved-chat-counter {
  color: #16a34a;
}
.terms-chat-comment {
  margin-top: 10px;
  padding: 10px 12px;
  border-top: 1px solid #e5e5e5;
}

.terms-chat-comment-label {
  font-size: 12px;
  font-weight: 500;
  color: #667085;
  margin-bottom: 4px;
}

.terms-chat-comment-text {
  font-size: 13px;
  line-height: 18px;
  color: #344054;
  white-space: pre-wrap;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/chat-communication/ChatMsgPad.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,8BAA8B;AAChC;AACA;;;EAGE,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA,2CAA2C;;AAE3C;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,wBAAwB;;AAExB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,uBAAuB;;AAEvB;;;EAGE,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;;AAE7B;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":[".chat-pad-container {\n  height: auto;\n  overflow-y: auto;\n  border-radius: 8;\n  margin-bottom: 12px;\n  padding: 20px;\n}\n.chat-pad-container-all {\n  height: 42vh;\n}\n.chat-disclaimer {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Medium;\n  font-size: 14px;\n  color: #000;\n  line-height: 18.2px;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  text-align: center;\n}\n.chat-pad-container {\n  max-height: 60vh;\n  overflow-y: auto;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  padding: 20px;\n  scrollbar-width: thin;\n  scrollbar-color: #98a2b3 transparent;\n}\n.rotate-icon {\n  transform: rotate(-90deg);\n}\n.chat-pad-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.chat-pad-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-pad-container::-webkit-scrollbar-thumb {\n  background: #98a2b3;\n  border-radius: 10px;\n}\n\n.chat-pad-container::-webkit-scrollbar-thumb:hover {\n  background: #667085;\n}\n\n.chat-pad-container-all {\n  height: 42vh;\n}\n@media (max-width: 769px) {\n  .chat-pad-container {\n    height: 430px;\n  }\n}\n.terms-chat-card {\n  width: 100%;\n  max-width: 390px;\n  padding: 14px 16px;\n  border: 1px solid #f5d15c;\n  border-radius: 16px;\n  background: #fffdf2;\n  box-sizing: border-box;\n  margin-top: 10px;\n}\n.terms-chat-card-counter {\n  border: 2px solid #d2042d !important;\n  background: #fff0f2 !important;\n}\n.terms-chat-card-counter-reciever {\n  background: #dbeafe !important;\n  border: 2px solid #1447e6 !important;\n}\n.terms-chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.terms-chat-title {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  color: #d97706;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.terms-chat-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: 1px solid #f5d15c;\n  border-radius: 50%;\n}\n\n.terms-chat-status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  background: #fff0b8;\n  color: #d97706;\n  font-size: 11px;\n  white-space: nowrap;\n}\n\n.terms-chat-total {\n  display: flex;\n  align-items: baseline;\n  gap: 7px;\n  margin-bottom: 12px;\n}\n\n.terms-chat-total-amount {\n  color: #101828;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.terms-chat-total-label {\n  color: #475467;\n  font-size: 12px;\n}\n\n.terms-chat-table {\n  overflow: hidden;\n  border: 1px solid #f5d15c;\n  border-radius: 12px;\n}\n.terms-chat-table .ant-table {\n  background: transparent;\n}\n\n.terms-chat-table .ant-table-container {\n  border: none !important;\n}\n\n.terms-chat-table .ant-table-thead > tr > th {\n  padding: 8px 10px;\n  background: #fff3c4 !important;\n  color: #d97706 !important;\n  font-size: 11px;\n  font-weight: 500;\n  border-bottom: 1px solid #f5d15c;\n}\n\n.terms-chat-table .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n\n.terms-chat-table .ant-table-tbody > tr > td {\n  padding: 9px 10px;\n  color: #344054;\n  font-size: 12px;\n  border-bottom: 1px solid #f5d15c;\n}\n\n.terms-chat-table .ant-table-tbody > tr:last-child > td {\n  border-bottom: none;\n}\n\n.terms-percentage {\n  color: #98a2b3;\n  font-size: 10px;\n}\n\n.terms-chat-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 9px 10px;\n  background: #fff8dc;\n  color: #d97706 !important;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.terms-chat-card {\n  padding: 12px 16px 14px;\n  border: 1px solid #f5d15c;\n  border-radius: 16px;\n  background: #fffdf2;\n  box-sizing: border-box;\n  margin-top: 0;\n}\n\n.terms-chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n.terms-chat-title {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  color: #d97706;\n  font-size: 12px;\n  font-weight: 500;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.terms-chat-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px !important;\n  height: 22px !important;\n  opacity: 1;\n  border-radius: 8px;\n  border-width: 1px;\n  border: 1px solid #d9770640 !important;\n  background: #fff3c4 !important;\n  color: #d97706;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n.terms-chat-approve-icon {\n  background: transparent !important;\n  color: #064e3b !important;\n  border: 1px solid #4ade80 !important;\n  background-color: #4ade80;\n}\n.terms-chat-icon-counter {\n  background-color: #d2042d !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n}\n.terms-chat-status {\n  padding: 4px 8px;\n  border-radius: 12px;\n  background: #fff0b8;\n  color: #d97706;\n  font-size: 11px;\n  font-weight: 400;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.terms-chat-status-counter {\n  color: #d2042d !important;\n  background-color: transparent !important;\n}\n.counter-header-text-sender {\n  color: #d2042d !important;\n}\n.terms-chat-status-counter-sent {\n  background-color: #dbeafe !important;\n}\n.counter-header-text {\n  color: #1447e6 !important;\n}\n.terms-chat-reciver-counter {\n  background: #fff0f2 !important;\n}\n.terms-chat-icon-counter-receiver {\n  background: #dbeafe !important;\n  border: 1px solid #1447e6 !important;\n  width: 16;\n  height: 16;\n  border-radius: 4px;\n}\n.terms-chat-total {\n  display: flex;\n  align-items: baseline;\n  gap: 7px;\n  margin-bottom: 14px;\n}\n\n.terms-chat-total-amount {\n  color: #101828;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.terms-chat-total-label {\n  color: #475467;\n  font-size: 11px;\n  font-weight: 400;\n}\n\n.terms-chat-table {\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid #f5d15c;\n  border-radius: 12px;\n}\n\n.terms-chat-table .ant-table {\n  background: transparent;\n}\n\n.terms-chat-table .ant-table-container {\n  border: none !important;\n}\n\n.terms-chat-table .ant-table-thead > tr > th {\n  padding: 7px 10px !important;\n  background: #fff3c4 !important;\n  color: #d97706 !important;\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  border-bottom: 1px solid #f5d15c !important;\n}\n\n.terms-chat-table .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n\n.terms-chat-table .ant-table-tbody > tr > td {\n  padding: 8px 10px !important;\n  color: #344054 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  border-bottom: 1px solid #f5d15c !important;\n}\n.terms-percentage {\n  color: #98a2b3 !important;\n  font-size: 10px !important;\n}\n\n.terms-chat-table .ant-table-tbody > tr.terms-chat-total-row > td {\n  padding: 8px 10px !important;\n  color: #d97706 !important;\n  font-size: 12px  !important;\n  font-weight: 600 !important;\n  border-bottom: none !important;\n}\n\n.counter-offer-chat-content {\n  padding: 0 2px 8px;\n}\n\n.counter-offer-chat-price {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  margin-bottom: 8px;\n}\n\n.counter-offer-chat-amount {\n  font-size: 24px;\n  line-height: 28px;\n  font-weight: 600;\n  color: #101828;\n}\n\n.counter-offer-chat-period {\n  font-size: 12px;\n  color: #475569;\n}\n\n.counter-offer-chat-schedule {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 12px;\n  color: #475569;\n  line-height: 20px;\n}\n\n.counter-offer-chat-dollar {\n  flex: 0 0 auto;\n  color: #98a2b3;\n  font-size: 13px;\n}\n\n.counter-offer-chat-schedule-label {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.counter-offer-chat-schedule-values {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.counter-offer-chat-schedule-row {\n  display: flex;\n  gap: 4px;\n  white-space: nowrap;\n}\n.counter-offer-chat-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.counter-offer-chat-actions .counter-offer-chat-accept,\n.counter-offer-chat-actions .counter-offer-chat-counter {\n  flex: 1;\n  height: 30px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.counter-offer-chat-accept {\n  background: #00a63e !important;\n  border-color: #00a63e !important;\n  color: #fff !important;\n}\n\n.counter-offer-chat-counter {\n  background: transparent !important;\n  border-color: #8b9cff !important;\n  color: #3b4eff !important;\n}\n.baground-color {\n  background: #dbeafe !important;\n}\n.text-bold-style {\n  font-family: Roboto;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n}\n.border-styles {\n  border-radius: 8px !important;\n  height: 30px !important;\n}\n.counter-chat-table {\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid #1447e6 !important;\n  border-radius: 12px;\n  background: #dbeafe !important;\n}\n.counter-chat-table .ant-table,\n.counter-chat-table .ant-table-container,\n.counter-chat-table .ant-table-content {\n  background: #dbeafe !important;\n}\n.counter-chat-table .ant-table-thead > tr > th {\n  padding: 7px 10px !important;\n  background: #93b4f8 !important;\n  color: #000 !important;\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  border-bottom: 1px solid #93b4f8 !important;\n}\n\n.counter-chat-table .ant-table-tbody > tr > td {\n  padding: 8px 10px !important;\n  background: #dbeafe !important;\n  color: #475569 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  border-bottom: 1px solid #93b4f8 !important;\n}\n\n.counter-chat-table .ant-table-tbody > tr.ant-table-row:hover > td {\n  background: #dbeafe !important;\n}\n.counter-chat-table .ant-table-tbody > tr:last-child > td {\n  border-bottom: none !important;\n}\n\n.counter-chat-table .ant-table-tbody > tr.terms-chat-total-row > td {\n  background: #dbeafe !important;\n  color: #475569 !important;\n  font-size: 12px;\n  font-weight: 600;\n  border-bottom: none !important;\n}\n\n.counter-chat-table .terms-percentage {\n  color: #64748b !important;\n  font-size: 10px;\n}\n\n.counter-chat-table .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n\n.counter-chat-table-seller {\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid #d2042d !important;\n  border-radius: 12px;\n  background: #fff0f2 !important;\n}\n\n.counter-chat-table-seller .ant-table,\n.counter-chat-table-seller .ant-table-container,\n.counter-chat-table-seller .ant-table-content {\n  background: #fff0f2 !important;\n}\n\n.counter-chat-table-seller .ant-table-thead > tr > th {\n  padding: 7px 10px !important;\n  background: #f5c2ca !important;\n  color: #d2042d !important;\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  border-bottom: 1px solid #f5c2ca !important;\n}\n\n.counter-chat-table-seller .ant-table-tbody > tr > td {\n  padding: 8px 10px !important;\n  background: #fff0f2 !important;\n  color: #475569 !important;\n  font-size: 12px !important;\n  font-weight: 400 !important;\n  border-bottom: 1px solid #f5c2ca !important;\n}\n.counter-chat-table-seller .ant-table-tbody > tr.ant-table-row:hover > td {\n  background: #fff0f2 !important;\n}\n.counter-chat-table-seller .ant-table-tbody > tr:last-child > td {\n  border-bottom: none !important;\n}\n\n.counter-chat-table-seller .ant-table-tbody > tr.terms-chat-total-row > td {\n  background: #fff0f2 !important;\n  color: #475569 !important;\n  font-size: 12px;\n  font-weight: 600;\n  border-bottom: none !important;\n}\n\n.counter-chat-table-seller .terms-percentage {\n  color: #98a2b3 !important;\n  font-size: 10px;\n}\n.counter-chat-table-seller .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n.offer-accepted-message {\n  width: 60%;\n  margin: 20px auto;\n  padding: 12px 16px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border: 2px solid #6ee7a0;\n  border-radius: 16px;\n  background: #f0fdf4;\n  font-family: Roboto;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n}\n\n/* Latest agreed message - Buyer & Seller */\n\n.agreed-latest-message {\n  background: #f0fdf4 !important;\n  border: 2px solid #4ade80 !important;\n  border-radius: 16px !important;\n  padding: 16px !important;\n  color: #064e3b !important;\n  box-shadow: none !important;\n}\n\n/* Accepted terms card */\n\n.terms-chat-card.agreed-latest-message {\n  background: #f0fdf4;\n  border: 2px solid #4ade80;\n  border-radius: 16px;\n}\n\n/* Accepted card text */\n\n.agreed-latest-message .terms-chat-title,\n.agreed-latest-message .terms-chat-total-amount,\n.agreed-latest-message .terms-chat-total-label {\n  color: #064e3b;\n}\n\n/* Green accepted status */\n\n.agreed-latest-message .terms-chat-status {\n  background: #dcfce7;\n  color: #15803d;\n  border-radius: 20px;\n  padding: 4px 10px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n/* Payment schedule / table */\n\n.agreed-latest-message .terms-chat-table {\n  background: transparent;\n  border: 1px solid #4ade80;\n}\n\n.agreed-latest-message .terms-chat-table .ant-table-cell {\n  background: transparent !important;\n  color: #064e3b !important;\n  border-bottom: 1px solid #4ade80 !important;\n}\n.offer-declined-message {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: fit-content;\n  max-width: 100%;\n  margin: 16px auto;\n  padding: 12px 24px;\n  border: 1px solid #e5e7eb;\n  border-radius: 24px;\n  background-color: #f3f4f6;\n  color: #64748b;\n  font-family: Roboto, sans-serif;\n  font-size: 13px;\n  line-height: 1.5;\n  text-align: left;\n}\n\n.declined-icon {\n  flex-shrink: 0;\n  color: #ff477e;\n  font-size: 16px;\n  font-weight: 600;\n}\n.approved-chat-counter {\n  color: #16a34a;\n}\n.terms-chat-comment {\n  margin-top: 10px;\n  padding: 10px 12px;\n  border-top: 1px solid #e5e5e5;\n}\n\n.terms-chat-comment-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #667085;\n  margin-bottom: 4px;\n}\n\n.terms-chat-comment-text {\n  font-size: 13px;\n  line-height: 18px;\n  color: #344054;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
